import React, { Component, useEffect, useState, useRef } from 'react';
import InputField from '../common/InputField';
import GlobalDropDown from '../common/GlobalDropDown/index'
import { CorStatus, Stage, Gender, CoeStatus, DownloadField } from './dependencies/constant/searchConstant'
import { getStateList, getSectorList, dowloadReport, generateReport, downloadExcelFile, GenerateSuiReport, RefreshSuiReport, downloadSuiPreviusReport, lastGeneratedReportHistory } from './dependencies/action';
import { getIndustryList, getStartupSector } from '../../components/startupApplication/dependencies/action'
import { connect } from 'react-redux';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import Button from '../common/Button'
import Download from '../common/Download';
import _ from 'lodash';
import SectionTitle from '../common/sectionTitle/sectionTitle';
import { Multiselect } from 'multiselect-react-dropdown'
import './style.scss'
import { toast } from "react-toastify";
import moment from 'moment/moment';
import downloadIcon from '../../assests/images/download-icon.png';
import refreshIcon from '../../assests/images/refresh-icon-green.png';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import downArrowBtn from '../../assests/images/down-arrow-btn.png';
import { useLoading } from '../LoadingContext';
import LoadingBar from '../LoadingBar';

const MonthlyReport80iac = (props) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [corStatus, SetCorStatus] = useState('');
    const [coeStatus, SetCoeStatus] = useState('');
    const [stage, SetStage] = useState('');
    const [gender, SetGender] = useState('');
    const [state, SetState] = useState('');
    const [sector, SetSector] = useState('');
    const [industry, SetIndustry] = useState('');
    const { getStartupSector, getIndustryList, getSectorList, getStateList, IndustryList, StateList, SectorList, dowloadReport, downloadExcelFile, generateReport, GenerateSuiReport, RefreshSuiReport, downloadSuiPreviusReport, lastGeneratedReportHistory } = props;
    const [selectedFields, setSelectedFields] = useState(DownloadField);
    const [csvFile, setCsvFile] = useState('');
    const [reportDetail, SetReportDetails] = useState({});
    const [openDateSelectionModal, setOpenDateSelectionModal] = useState(false);
    const [openHistory, setOpenHistory] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(false);
    const [lastThreeMonths, setLastThreeMonths] = useState([]);
    const [historyData, setHistoryData] = useState({});
    const { isLoading, setIsLoading } = useLoading();




    useEffect(() => {
        const months = [];
        const today = new Date();
        let targetMonth = today.getMonth() - 1;
        let targetYear = today.getFullYear();
        for (let i = 0; i < 3; i++) {
            if (targetMonth === -1) {
                targetMonth = 11;
                targetYear -= 1;
            }
            const targetDate = new Date(targetYear, targetMonth, 1);
            const monthName = targetDate.toLocaleString('default', { month: 'long' });
            const monthNumber = `${String(targetMonth + 1).padStart(2, '0')}-${targetYear}`;
            months.push({
                name: `${monthName} ${targetYear}`,
                number: monthNumber
            });
            targetMonth -= 1;
        }
        setLastThreeMonths(months);
    }, []);

    const handleInput = (e, type) => {
        let value = e.target.value;
        if (type === 'startDate') {
            setStartDate(value);
        } else if (type === 'endDate') {
            setEndDate(value);
        } else if (type === 'corStatus') {
            SetCorStatus(value);
        } else if (type === 'coeStatus') {
            SetCoeStatus(value);
        } else if (type === 'state') {
            SetState(value);
        } else if (type === 'sector') {
            SetSector(value);
        } else if (type === 'stage') {
            SetStage(value);
        } else if (type === 'gender') {
            SetGender(value);
        } else if (type === 'industry') {
            SetIndustry(value);
        }
    }

    function downloadStartupDetail(e) {
        if (dowloadReport) {
            let formattedStartDate = startDate ? `${startDate}T00:00:00.000Z` : '';
            let formattedEndDate = endDate ? `${endDate}T23:59:59.999Z` : '';

            let query = {
                "endDate": formattedEndDate,
                "startDate": formattedStartDate,
            }

            for (var propName in query) {
                if (query[propName] === null || query[propName] === undefined || query[propName] === '') {
                    delete query[propName];
                }
            }

            const payload = {
                sortColumn: "createdDate",
                sortOrder: "desc",
                fetchAllRecords: true,
                query
            };

            return dowloadReport(payload).then((response) => {

                const { data } = response;
                const fileName = "report";

                e.preventDefault();
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                if (data) {
                    const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // for .xlsx
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = `${fileName}.xlsx`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }

            })
        }
    }

    function handledownloadPreviusSuiReport(e) {

        if (downloadSuiPreviusReport && e.target.value) {

            // "endDate": "2020-06-06T17:01:25.190Z",
            // "gender": "MALE",
            // "startDate": "2020-01-01T17:01:25.190Z",
            const headers = selectedFields.reduce((arr, option) => {
                if (option['dataField']) {
                    arr.push(option['dataField']);
                }
                return arr;
            }, []);

            let query = {
                "endDate": endDate,
                "startDate": startDate,
                headers,
            }

            for (var propName in query) {
                if (query[propName] === null || query[propName] === undefined || query[propName] === '') {
                    delete query[propName];
                }
            }

            return downloadSuiPreviusReport({ query, month: e.target.value }).then((response) => {

                const { data } = response;
                const fileName = "report";

                e.preventDefault();
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                if (data) {
                    const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // for .xlsx
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = `${fileName}.xlsx`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                // return data;
            })
        }
    }


    function openDateModal() {
        setOpenDateSelectionModal(true);

    }

    async function GenerateStartupDetail(e) {
        e.preventDefault();
        setIsLoading(true);
        toast.success('Report Generation Started - Please Wait For Some Time To Download File.');

        let formattedStartDate = startDate ? `${startDate}T00:00:00.000Z` : '';
        let formattedEndDate = endDate ? `${endDate}T23:59:59.999Z` : '';

        let query = {
            "endDate": formattedEndDate,
            "startDate": formattedStartDate,
        }

        for (var propName in query) {
            if (query[propName] === null || query[propName] === undefined || query[propName] === '') {
                delete query[propName];
            }
        }

        const payload = {
            sortColumn: "createdDate",
            sortOrder: "desc",
            fetchAllRecords: true,
            query
        };
        try {
            const response = await dowloadReport(payload);
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            toast.error('Something went wrong during report generation.');
        } finally {
            setIsLoading(false);
        }
    }








    function GenerateReport(e) {
        let startDateObj = new Date(startDate);
        let endDateObj = new Date(endDate);

        let diffInMonths = (endDateObj.getFullYear() - startDateObj.getFullYear()) * 12 +
            (endDateObj.getMonth() - startDateObj.getMonth());


        let diffInDays = endDateObj.getDate() - startDateObj.getDate();


        if (diffInDays < 0) {

            diffInMonths--;


            let lastMonthEndDate = new Date(startDateObj.getFullYear(), startDateObj.getMonth() + 1, 0);
            diffInDays += lastMonthEndDate.getDate();
        }

        if (diffInMonths > 6 || (diffInMonths === 6 && diffInDays > 0)) {

            GenerateStartupDetail(e);
        } else {

            downloadStartupDetail(e);
        }
        setOpenDateSelectionModal(false);
        setStartDate('');
        setEndDate('')


    }

    const openHistoryModal = async () => {
        let data = await lastGeneratedReportHistory();
        if (data?.status) {
            setHistoryData(data?.data)
        }
        setOpenHistory(true);
    }

    const toggleDateSelectionModal = () => {
        setOpenDateSelectionModal(false);
        setStartDate('');
        setEndDate('')
    }

    const closeHistoryModal = () => {
        setOpenHistory(false);
    }
    const handleOpenDropdown = () => {
        setOpenDropdown(!openDropdown);
    }


    // const currentYear = new Date().getFullYear();
    // const dateString = `${currentYear}-12-31`; 
    const today = new Date().toISOString().split("T")[0];
    const minAllowedDate = "2016-01-01";
    return (
        <>
            <div className="startup-report">
                <SectionTitle>80-IAC Report</SectionTitle>
                <div className="filter-form custom-form" >


                    <div className="row">
                        <div className="col-md-12">
                            <div className='d-flex justify-content-between Refresh-abt'>
                                <label className='fields-line'>Fields</label>
                                <div className='Refresh-btn'>
                                    <a className='text-success' onClick={() => window.location.reload()}>
                                        <img width="15" style={{ marginRight: '5px' }} src={refreshIcon} />
                                        Refresh &nbsp;</a>
                                </div>
                            </div>
                            <div className='fields-list'>
                                <ul>
                                    {DownloadField?.map((el => <>
                                        <li>{el?.text}</li>
                                    </>))}

                                </ul>
                            </div>

                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-12 d-flex justify-content-between pt-20 mb-3'>
                            <div>
                                <button
                                    className={isLoading ? 'disabledButton' : 'download80iac'}
                                    onClick={(event) => openDateModal(event)}
                                    disabled={isLoading}                       >
                                    {'Download 80-IAC Report'}
                                </button>

                            </div>

                            <div onClick={handleOpenDropdown}
                                className={`download-container bttn dropdown-check ${openDropdown ? 'show' : ""}`}
                            >
                                {'Last Month 80-IAC Report'}    <img width="15" src={downArrowBtn} />

                                <ul>
                                    {lastThreeMonths?.map((el, index) => (
                                        <li key={index} onClick={(event) => handledownloadPreviusSuiReport(event)}>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" value={el?.number} id={`checkbox-${index}`} name="month" />
                                                <label className="form-check-label" htmlFor={`checkbox-${index}`}>
                                                    {el?.name}
                                                </label>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>


                    </div>
                    {isLoading && (
                        <div className="spinner">
                            <LoadingBar />
                            <span>⏳ Generating Report...</span>
                        </div>
                    )}
                    <span className='text-success' style={{ fontSize: '16px' }}>Last Generated Report:
                    </span><button className='history-btn' onClick={openHistoryModal}>History</button>


                </div >


            </div>
            <Modal isOpen={openDateSelectionModal} toggle={toggleDateSelectionModal} className="sui-monthly-report">
                <ModalHeader toggle={toggleDateSelectionModal}>
                    Download 80-IAC Report
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="startdate col-md-6">
                            <InputField
                                type="date"
                                name="startDate"
                                label="From Date"
                                value={startDate}
                                min={minAllowedDate}
                                max={endDate || today} // max is endDate if selected, else current year end
                                onChange={handleInput}
                                containerClass="form-group"
                                placeholder="Search"
                                required
                            />
                        </div>
                        <div className="endDate col-md-6">
                            <InputField
                                type="date"
                                name="endDate"
                                label="To Date"
                                value={endDate}
                                min={startDate || minAllowedDate} // can't be before startDate
                                max={today} // always limited to current year
                                onChange={handleInput}
                                containerClass="form-group"
                                placeholder="Search"
                                required
                            />
                        </div>
                    </div>
                </ModalBody>

                <ModalFooter>
                    <div className="button-container">
                        <button className="download-container downloadReport-sui" onClick={(event) => GenerateReport(event)} disabled={!startDate || !endDate}>
                            Download
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
            <Modal isOpen={openHistory} toggle={closeHistoryModal} className="last-generated-report">
                <ModalHeader toggle={closeHistoryModal}>
                    Last Downloaded Report
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className='last-generated'>
                            <ul>
                                {historyData && historyData['Date'] && historyData["StartDate"] && historyData['EndDate'] &&
                                    <>
                                        <li><strong>Name : </strong> <p>{historyData['Name']}</p></li>
                                        <li><strong>Date : </strong> <p>{moment(historyData['Date']).format('DD/MM/YYYY')}</p></li>
                                        <li><strong>Query : </strong> <p>{`Since ${moment.utc(historyData["StartDate"]).format('DD/MM/YYYY')} - ${moment.utc(historyData['EndDate']).format('DD/MM/YYYY')}`}</p></li>
                                    </>
                                }
                            </ul>
                        </div>

                    </div>

                </ModalBody>
                <ModalFooter>
                    <div className="button-container">
                        <button className="download-container downloadReport-Generated" onClick={(event) => closeHistoryModal(event)}>
                            Ok
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        StateList: state.StartupDetailReport.reportStateList,
        IndustryList: state.startupApplicationForm.startupIndustry,
        SectorList: state.startupApplicationForm.startupEntitySector,
    }
}

export default connect(mapStateToProps, { lastGeneratedReportHistory, getStartupSector, getSectorList, getStateList, dowloadReport, generateReport, downloadExcelFile, getIndustryList, GenerateSuiReport, RefreshSuiReport, downloadSuiPreviusReport })(withRouter(MonthlyReport80iac));